// filepath: apps/web/src/features/directory/teams/TeamsRoute.tsx
//
// FR-UI-DIR-1 AC-7 — route shell for /teams.

import { TeamsPage } from "./TeamsPage";

export function TeamsRoute(): React.ReactElement {
  return <TeamsPage />;
}
